import { useShipmentsOverviewContext } from '@/modules/pmt/context';
import { PMTAdType } from '../../constants';
import { CustomAdsense } from './MyParcelsLeftAd.styles';

export const MyParcelsLeftAd = () => {
  const { noShipmentsAdded } = useShipmentsOverviewContext();

  if (!noShipmentsAdded) return null;

  return <CustomAdsense className='pmt-below-parcel-list' variant={PMTAdType.PMT_SQUARE_AD} />;
};
